import { __spreadArray } from "tslib";
import publicSessionSaga from '../../publicSession/saga';
import commentEditorSaga from '../../CommentEditor/redux/saga';
import commentThreadSaga from '../../CommentThread/saga';
import emoteSelectorSaga from '../../EmoteSelector/redux/saga';
import watchButtonSaga from '../../WatchButton/redux/saga';
import writerSaga from '../../WriterPopup/redux/saga';
import statusEditPopupSaga from '../../StatusEditPopup/saga';
import mediaPopupSaga from '../../MediaPopup/saga';
import userAvatarSaga from '../../User/AvatarPopover/saga';
import streamSagas from '../../Stream/sagas';
import usersSaga from '../users/saga';
import deviationsSaga from '../deviations/saga';
import commissionsSaga from '../commissions/saga';
import loggedOutSaga from '../loggedout/saga';
import editorsSaga from '../../DaEditorWrapper/redux/saga';
import mentionSaga from '../../DaEditorWrapper/AsyncHandlers/Mentions/saga';
import deviationPasteSaga from '../../DaEditorWrapper/AsyncHandlers/DeviationPaste/saga';
import fetchFreshSaga from '../../DaEditorWrapper/AsyncHandlers/FetchFresh/saga';
import pollEditSaga from '../../PollEditPopup/redux/sagas';
import collectionPanelSaga from '../../CollectionPanel/redux/saga';
import firstTimeFlagsSaga from '../firstTimeFlags/saga';
import measuredCookieSaga from '../../Measured/redux/saga';
import siteHeaderSaga from '../../SiteHeader/redux/saga';
import duperbrowseSaga from '../../Duperbrowse/redux/saga';
import deviationBackgroundSaga from '../../DeviationBackground/redux/saga';
import moderationSaga from '../../Moderation/redux/saga';
import whoSaga from '../../Who/redux/saga';
import deviationPageSaga from '../../DeviationPage/redux/saga';
import addToGroupSaga from '../../AddToGroupsPanel/redux/saga';
import groupsSaga from '../../redux/groups/saga';
import watchSuggestionsSaga from '../../WatchSuggestions/redux/saga';
import pollViewSaga from '../../PollView/redux/saga';
import artBrandedPopupSaga from '../../ArtBrandedPopup/redux/saga';
// import { modulelessPortfolioSaga as wixPortfolioSaga } from '../../WixPortfolio/redux/saga';
import biSaga from '../../biLogger/redux/saga';
import hubSaga from '../hub/saga';
import modalSaga from '../../Modals/redux/saga';
import messagesSaga from '../messages/saga';
import compliantLocalStorageSaga from '../../redux/compliantLocalStorage/saga';
import coreBadgeSaga from '../../coreBadge/redux/saga';
import networkbarSaga from '../../NetworkBar/redux/saga';
import simpleXHRSaga from '../../simpleXHR/saga';
import favouritedByModalSaga from '../../FavouritedByModal/redux/saga';
import uploadsSaga from '../uploads/saga';
import tagInputSaga from '../../TagInput/redux/saga';
import reportPageSaga from '../../ReportPage/redux/saga';
import deviationGroupListSaga from '../../DeviationGroupListPopup/redux/saga';
import earningsDisplaySaga from '../../EarningsDisplay/redux/saga';
export var sagas = __spreadArray([
    publicSessionSaga,
    commentEditorSaga,
    commentThreadSaga,
    usersSaga,
    deviationsSaga,
    commissionsSaga,
    emoteSelectorSaga,
    watchButtonSaga,
    writerSaga,
    mediaPopupSaga,
    statusEditPopupSaga,
    userAvatarSaga,
    editorsSaga,
    mentionSaga,
    deviationPasteSaga,
    fetchFreshSaga,
    pollEditSaga,
    collectionPanelSaga,
    loggedOutSaga,
    firstTimeFlagsSaga,
    measuredCookieSaga,
    siteHeaderSaga,
    duperbrowseSaga,
    deviationBackgroundSaga,
    moderationSaga,
    whoSaga,
    deviationPageSaga,
    addToGroupSaga,
    groupsSaga,
    watchSuggestionsSaga,
    pollViewSaga,
    artBrandedPopupSaga,
    biSaga,
    hubSaga,
    modalSaga,
    messagesSaga,
    compliantLocalStorageSaga,
    coreBadgeSaga,
    networkbarSaga,
    simpleXHRSaga,
    favouritedByModalSaga,
    uploadsSaga,
    tagInputSaga,
    reportPageSaga,
    deviationGroupListSaga,
    earningsDisplaySaga
], streamSagas, true);
//# sourceMappingURL=sagas.js.map